const normalizeBase = (value) => String(value || '').trim().replace(/\/+$/, '');

const isLoopbackHost = (hostname = '') => {
  const host = String(hostname || '').toLowerCase();
  return host === 'localhost' || host === '127.0.0.1' || host === '::1';
};

const isLoopbackUrl = (value) => {
  try {
    const parsed = new URL(value);
    return isLoopbackHost(parsed.hostname);
  } catch {
    return false;
  }
};

export const resolveApiBaseUrl = () => {
  const envBase = normalizeBase(process.env.REACT_APP_API_BASE_URL);

  // In CRA dev mode, use same-origin requests and rely on dev-server proxy.
  // This avoids mobile devices needing direct access to backend port 3000.
  if (process.env.NODE_ENV === 'development') {
    // Ignore localhost/127.0.0.1 overrides when app is opened from another device.
    // That would point API calls to the phone itself and fail.
    if (envBase && !isLoopbackUrl(envBase)) return envBase;
    return '';
  }

  if (envBase) return envBase;

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
    return `${protocol}//${window.location.hostname}:3000`;
  }

  return 'http://localhost:3000';
};

export const API_BASE_URL = resolveApiBaseUrl();
